// Small browser file helpers the editor needs.
//
// Copied rather than imported: `apps/web/app/lib/pdf-utils.ts` carries
// the same four functions for the other PDF tools, but this package
// must stand alone for consumers outside this repo. They are small,
// generic, and stable enough that duplication beats a shared package.

export function bytesToPdfBlob(bytes: Uint8Array): Blob {
  // BlobPart wants ArrayBuffer-backed views; copy into a fresh buffer
  // so the strict TS types are satisfied.
  const copy = new Uint8Array(bytes.byteLength);
  copy.set(bytes);
  return new Blob([copy], { type: "application/pdf" });
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function pdfFilename(original: string, suffix: string, ext = "pdf"): string {
  const dot = original.lastIndexOf(".");
  const stem = dot > 0 ? original.slice(0, dot) : original;
  return `${stem}.${suffix}.${ext}`;
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
